import { render, staticRenderFns } from "./WideSearch.vue?vue&type=template&id=69905d86&"
import script from "./WideSearch.vue?vue&type=script&lang=js&"
export * from "./WideSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69905d86')) {
      api.createRecord('69905d86', component.options)
    } else {
      api.reload('69905d86', component.options)
    }
    module.hot.accept("./WideSearch.vue?vue&type=template&id=69905d86&", function () {
      api.rerender('69905d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/WideSearch.vue"
export default component.exports